import React, { useState, useEffect } from "react";
import { Button, CustomSelect, TextInput } from "..";
import { copyTextToClipboard } from "../../utils";
import PasswordInput from "../Password/PasswordInput";

interface UserDetailsFTPProps {
  status?: any;
  currentUser?: any;
  updateUser?: any;
  email?: string;
  pass?: string;
  showUpdate?: boolean;
  handleStatusChange?: any;
  handlePasswordChange?: any;
}

const UserDetailsFTP: React.FC<UserDetailsFTPProps> = ({
  status,
  email,
  pass,
  updateUser,
  currentUser,
  showUpdate = true,
  handleStatusChange,
  handlePasswordChange,
}) => {
  // Build permission options
  const [ftpStatus, setFtpStatus] = useState<any>(status);
  const [password, setPassword] = useState(pass || ""); // Replace with actual password

  const [initialPassword, setInitialPassword] = useState(pass || "");
  const [initialFtpStatus, setInitialFtpStatus] = useState(status || 0);
  const [isDirty, setIsDirty] = useState(false);

  const generatePassword = (length: number) => {
    const chars =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  const handleCopyPassword = () => {
    copyTextToClipboard(password);
  };

  const handlePassword = (value: string) => {
    setPassword(value);
    handlePasswordChange?.(value);
  };

  const handleUpdateUser = () => {
    const data = {
      email: email,
      status: ftpStatus,
      password: password,
    };

    updateUser({ ftp: data, id: currentUser?.id });
  };

  useEffect(() => {
    setPassword(pass || "");
    setFtpStatus(status || 0);

    setInitialPassword(pass || "");
    setInitialFtpStatus(status || 0);
  }, [pass, status]);

  useEffect(() => {
    setIsDirty(password !== initialPassword || ftpStatus !== initialFtpStatus);
  }, [password, ftpStatus, initialPassword, initialFtpStatus]);

  return (
    <>
      <div className="card p-0" style={{}}>
        {/* <div className="px-3 py-2 border-bottom">
          <h6 className="me-2">SECURITY</h6>
        </div> */}
        <div className="card-header d-flex align-items-center justify-content-between">
          <h6>FTP Login</h6>
          <CustomSelect
            label=""
            // placeholder="Draft"
            maintainSelectHeight="20px"
            value={ftpStatus}
            handleChange={(newValue: any) => {
              setFtpStatus(newValue.value);
              handleStatusChange?.(newValue.value);
            }}
            className="gap-0 m-0 p-0"
            options={[
              {
                label: "ON",
                value: 1,
              },
              {
                label: "OFF",
                value: 0,
              },
            ]}
            handleBlur={() => {}}
            error={""}
            touched={false}
            updatedOptions={[
              {
                label: "ON",
                value: 1,
              },
              {
                label: "OFF",
                value: 0,
              },
            ]}
          />
        </div>
        {ftpStatus === 1 && (
          <div className="card-body row">
            <div className="col-4">
              <TextInput
                name="email"
                label="Login"
                value={email || ""}
                onChange={(e) => console.log(e)}
                onBlur={() => {}}
                showRequired={false}
                error={""}
                disabled={true}
                touched={false}
              />
            </div>
            <div className="col-8 px-3">
              <PasswordInput
                label="Password"
                name="password"
                value={password}
                password={password}
                updateHandler={handleUpdateUser}
                showUpdate={showUpdate}
                isDirty={isDirty}
                onChange={handlePassword}
              />
              {/* {showUpdate && (
                <div className="align-content-center">
                  <Button className="btn btn-primary" onClick={handleUpdateUser} isDisabled={!isDirty || !password}>
                    Update
                  </Button>
                </div>
              )} */}
            </div>
          </div>
        )}
      </div>
      {/* </div> */}
    </>
  );
};

export default UserDetailsFTP;
